// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_EBK","cls2":"PaperClaimedToast-cls2_EQW PaperClaimedToast-cls1_EBK"};